var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.0031 4.6875C1.54487 4.22927 0.801914 4.22927 0.34368 4.6875C-0.114565 5.14575 -0.114555 5.88869 0.34368 6.34692L4.55446 10.5577C5.01269 11.0159 5.75564 11.0159 6.21388 10.5577L14.6562 2.1154C15.1144 1.65717 15.1144 0.914215 14.6562 0.455981C14.1979 -0.00225395 13.455 -0.00225395 12.9968 0.455981L5.38417 8.06857L2.0031 4.6875Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.9dc777f839693836c7c6903d484ea8cd.svg";
export { ForwardRef as ReactComponent };